"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSegmentNext = exports.SEGMENT_CDN_HOST = void 0;
const analytics_next_1 = require("@segment/analytics-next");
const consent_wrapper_1 = require("./consent-wrapper");
const screen_context_middleware_1 = require("./screen-context-middleware");
exports.SEGMENT_CDN_HOST = 'https://cdn.insights.pleo.io';
const initSegmentNext = (writeKey, cdnHost = exports.SEGMENT_CDN_HOST, isReady = () => true) => {
    const analytics = new analytics_next_1.AnalyticsBrowser();
    const browser = (0, consent_wrapper_1.createSegmentConsentWrapper)(isReady)(analytics);
    browser.addSourceMiddleware(screen_context_middleware_1.enrichWithScreenContext);
    browser.load({ writeKey, cdnURL: cdnHost });
    // window.analytics must be set so consumers in segment-helpers.ts work.
    window.analytics = browser;
    return browser;
};
exports.initSegmentNext = initSegmentNext;
